/**
 * Open the platform store page for the app (used by the update gate / prompt).
 */

import { Linking } from 'react-native';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../../../constants/storeLinks';
import { logger } from '../../helpers/logger.helper';
import type { AppPlatform } from './appVersionApi.helper';

export async function openAppStore(platform: AppPlatform): Promise<void> {
  const url = platform === 'ios' ? APP_STORE_URL : GOOGLE_PLAY_URL;
  try {
    await Linking.openURL(url);
  } catch (error) {
    logger.warn('[openAppStore] failed to open store', {
      platform,
      message: error instanceof Error ? error.message : String(error),
    });
  }
}
